import { render, staticRenderFns } from "./mygroup.vue?vue&type=template&id=d2dcd2f4&scoped=true"
import script from "./mygroup.vue?vue&type=script&lang=js"
export * from "./mygroup.vue?vue&type=script&lang=js"
import style0 from "./mygroup.vue?vue&type=style&index=0&id=d2dcd2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dcd2f4",
  null
  
)

export default component.exports